import { lazy } from 'react';

export const createLazyImports = componentPaths => {
    return Object.fromEntries(Object.entries(componentPaths).map(([key, importFn]) => [key, lazy(importFn)]));
};